let loadSpeechSynthesis = () => {
  return new Promise(
    function (resolve) {
      let synth = window.speechSynthesis;
      let id;
      id = setInterval(() => {
        if (synth.getVoices().length !== 0) {
          resolve(synth.getVoices());
          clearInterval(id);
        }
      }, 10);
    }
  )
}

let loadVoices = () => {
  return new Promise((resolve) => {
    loadSpeechSynthesis().then(result => {
      let base = ['en', 'es', 'de', 'fr', 'it', 'ru'];
      let filtered = result.filter(lang => {
        return base.includes(lang.lang.slice(0,2));
      })
      resolve(filtered);
    })
  })
}

export default loadVoices;